export default __webpack_public_path__ + "static/media/00.8c715750.jpg";